import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, CssBaseline, StyledEngineProvider, ThemeProvider } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200
    }
  },
  palette: {
    mode: "light",
    primary: {
      main: "#5AB9F9",
      light: "#fdf6f6"
    },
    secondary: {
      main: "#D7D7D7",
      contrastText: "#333"
    },
    warning: {
      main: "#F4D356"
    },
    success: {
      main: "#5AB9F9"
    },
    error: {
      main: "#EB0000"
    }
  },
  typography: {
    h1: {
      fontFamily: ["Krona One"].join(",")
    },
    h2: {
      fontFamily: ["Krona One"].join(",")
    },
    h3: {
      fontFamily: ["Krona One"].join(",")
    },
    h4: {
      fontFamily: ["Krona One"].join(",")
    },
    h5: {
      fontFamily: ["Krona One"].join(",")
    },
    h6: {
      fontFamily: ["Krona One"].join(",")
    },
    body1: {
      fontFamily: ["Montserrat"].join(",")
    },
    body2: {
      fontFamily: ["Montserrat"].join(",")
    },
    fontFamily: ["Montserrat"].join(",")
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <StyledEngineProvider injectFirst>
    <CssBaseline />
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StyledEngineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
